import {STORE_CREDITS_DATA, SET_REMAINING_CREDITS, CHANGE_EXTRA_ITEM_QUANTITY} from '../../actions/actionTypes';

export function storeCreditsReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case STORE_CREDITS_DATA:
            return Object.assign({}, state,
                {
                    creditType: action.storeCreditsData.creditType,
                    credits: action.storeCreditsData.credits,
                    deliveryDate: action.storeCreditsData.deliveryDate,
                    extraCreditItem: action.storeCreditsData.extraCreditItem,
                    remainingCredits: action.storeCreditsData.remainingCredits,
                    usedFarmigoCredits: action.storeCreditsData.usedFarmigoCredits,
                    balanceAsCredits: action.storeCreditsData.balanceAsCredits
                });
        case SET_REMAINING_CREDITS:
            return Object.assign({}, state,
                {
                   remainingCredits: action.remainingCredits
                });
        case CHANGE_EXTRA_ITEM_QUANTITY:
            if(state.extraCreditItem.key === action.key) {
                return Object.assign({}, state,
                    {
                        extraCreditItem: Object.assign({}, state.extraCreditItem, {quantity: action.newQuantity})
                    });
            }
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/store/storeCreditsReducer.js